import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'chevron-compact-up',
  'IconChevronCompactUp',
  [['path', { d: 'M4 13l8 -3l8 3', key: 'svg-0' }]],
);
